import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minutesToHour',
})
export class MinutesToHourPipe implements PipeTransform {
  transform(value: number, isFullLabel = false): string {
    const minutes = isFullLabel ? ' minutes' : 'm';
    const hours = isFullLabel ? ' hour(s)' : 'h';

    if (value > 0 && value / 60 < 1) {
      return value + minutes;
    } else if (value % 60 === 0) {
      return value / 60 + hours;
    } else {
      return Math.floor(value / 60) + hours + ' ' + (value % 60) + minutes;
    }
  }
}
